import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogAgentStopped_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';

import useIsAiTaskEnabled from 'src/hooks/useIsAiTaskEnabled';

interface Fragments {
  activityLog: ActivityLogAgentStopped_ActivityLogFragment;
}

const ActivityLogAgentStopped: FCWithFragments<Fragments> = ({ activityLog }) => {
  const aiTaskEnabled = useIsAiTaskEnabled();
  if (!aiTaskEnabled) {
    return null;
  }

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.stoppedAiAgent"
      actionLabelValues={{}}
    />
  );
};

ActivityLogAgentStopped.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogAgentStopped_activityLog on ActivityLog {
      id
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogAgentStopped;
